var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-tabs',_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.key,attrs:{"to":tab.to,"data-test":tab.key,"exact-path":""}},[_vm._v(_vm._s(_vm.$t(tab.name))+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }